import React from "react";
import { Card, CardContent, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ArrowRightOutlinedIcon from "@mui/icons-material/ArrowRightOutlined";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

const StyledCard = styled(Card)(
  ({ theme, selected, initialBgColor, selectedBorderColor }) => ({
    position: "relative",
    border: selected ? `3px solid ${selectedBorderColor}` : `2px solid #ddd`,
    boxShadow: selected ? `0 6px 12px rgba(0, 0, 0, 0.3)` : "none",
    transition: "transform 0.2s, box-shadow 0.2s, background-color 0.2s",
    transform: selected ? "scale(1.06)" : "scale(1)",
    height: "auto",
    display: "flex",
    flexDirection: "column",
    borderRadius: "12px",
    padding: "20px",
    alignItems: "center",
    textAlign: "center",
    backgroundColor: selected ? "#fff" : initialBgColor,
    "&:hover": {
      transform: "scale(1.05)",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    },
  })
);

const Checkmark = styled(CheckCircleIcon)(({ theme }) => ({
  position: "absolute",
  top: 8,
  right: 8,
  color: theme.palette.primary.main,
  backgroundColor: "#fff",
  borderRadius: "50%",
  width: 24,
  height: 18,
}));

const PopularBadge = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: 12,
  left: 12,
  backgroundColor: theme.palette.secondary.main,
  color: "#fff",
  padding: "4px 8px",
  borderRadius: "4px",
  fontSize: "0.75rem",
  fontWeight: "bold",
}));

const FeaturesList = styled(Box)({
  textAlign: "left",
  marginTop: "16px",
  width: "100%",
  marginBottom: "20px",
});

const FeatureItem = styled(Box)({
  display: "flex",
  alignItems: "center",
  marginBottom: "8px",
});

const FeatureText = styled(Typography)({
  marginLeft: "8px",
});

const CardComponent = ({
  title,
  price,
  offer,
  features,
  isSelected,
  onClick,
  initialBgColor,
  selectedBorderColor,
}) => (
  <StyledCard
    selected={isSelected}
    onClick={onClick}
    initialBgColor={initialBgColor}
    selectedBorderColor={selectedBorderColor}
  >
    {isSelected && <Checkmark />}
    <CardContent
      sx={{ flex: "1 0 auto", paddingBottom: "20px", textAlign: "center" }}
    >
      <Typography
        variant="h5"
        component="div"
        sx={{ color: isSelected ? "#000" : title.color, fontWeight: "bold" }}
      >
        {title.text}
        {isSelected}
      </Typography>
      <Typography variant="h6" color="textSecondary" sx={{ mt: 1, mb: 1 }}>
        {price}
      </Typography>
      <Typography variant="subtitle2" color="textSecondary" sx={{ mb: 2 }}>
        {offer}
      </Typography>
      <FeaturesList>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
          Features
        </Typography>
        {features.map((feature, index) => (
          <FeatureItem key={index}>
            <ArrowRightOutlinedIcon fontSize="small" color="primary" />
            <FeatureText variant="body2" color="textSecondary">
              {feature}
            </FeatureText>
          </FeatureItem>
        ))}
      </FeaturesList>
    </CardContent>
  </StyledCard>
);

export default CardComponent;
